import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/footer/Footer';
import PayHeader from '../components/pay/payHeader';
import PriceTable from '../components/pay/PriceTable';
import Payment from '../../service/pay/pay';
import Menu from '../components/menu/Menu';
import MembershipDetail from '../components/pay/MembershipDetail';
import ItemBase from '../components/pay/ItemBase';
import s from '../components/pay/membership.Style';
import ComparePlan from '../components/pay/plan/ComparePlan';
import ComparePrice from '../components/pay/plan/ComparePrice';
import PageTop from '../components/pageTop/PageTop';

interface MembershipPlan {
  type: string;
  plan_id: number;
  plan_name: string;
  plan_prc: number;
  is_discount: string;
}

const AgentPaymentPlan = () => {
  const [standardPlans, setStandardPlans] = useState<MembershipPlan[]>([]);
  const [premiumPlans, setPremiumPlans] = useState<MembershipPlan[]>([]);

  const [selectedMonth, setSelectedMonth] = useState(12);
  const monthList = [1, 3, 6, 12];

  const handleMonthClick = (month: number) => {
    setSelectedMonth(month);
  };

  const getMembershipPlan = async (month: number, type: string) => {
    try {
      const res = await Payment.membershipPlan(month, type);
      setStandardPlans(res.data.standard || []);
      setPremiumPlans(res.data.premium || []);
    } catch (error) {
      alert('상품 목록을 불러오는 데 실패했습니다.');
    }
  };

  useEffect(() => {
    getMembershipPlan(selectedMonth, 'G');
  }, [selectedMonth]);

  return (
    <Container>
      <PageTop logo hasSearch={false} hasBackCloseButton={false} />
      <Section>
        <Top>
          <TitleBox>
            <PageTitle>공인중개사 전용 특전</PageTitle>
          </TitleBox>
          <Description>
            지금 바로 구매하고 유료 회원에게만 제공되는
            <br />
            특별한 서비스를 누려보세요.
          </Description>
        </Top>
        <TitleBox>
          <Option>
            {monthList.map((month) => (
              <OptionButton
                style={{
                  filter: month !== 12 ? 'brightness(70%)' : 'brightness(100%)',
                  opacity: month !== 12 ? 0.5 : 1,
                  cursor: month !== 12 ? 'not-allowed' : 'pointer',
                }}
                key={month}
                selected={selectedMonth === month}
                onClick={
                  month === 12 ? () => handleMonthClick(month) : undefined
                }
              >
                {month}개월
              </OptionButton>
            ))}
          </Option>
          <Membership>
            {standardPlans.length > 0 && (
              <ItemBase
                plans={standardPlans}
                month={selectedMonth}
                props={{
                  title: 'Standard',
                  subTitle: '전국 요금제',
                  description: (
                    <s.Comment>
                      합리적인 가격으로 나에게 맞는 알고리즘을 만들고
                      투자보고서도 받아보세요
                    </s.Comment>
                  ),
                  recommend_code: '8888',
                }}
              />
            )}
            {selectedMonth === 12 && premiumPlans.length > 0 && (
              <ItemBase
                plans={premiumPlans}
                month={selectedMonth}
                props={{
                  title: 'Premium',
                  subTitle: '전국 프리미엄',
                  description: (
                    <s.Comment>
                      감으로 경매 하지 마세요
                      <br />돈 되는 경매를 알려주는 경매 고수들을 위한 서비스
                    </s.Comment>
                  ),
                  recommend_code: '8888',
                }}
              />
            )}
            <Note>
              ※ 본 페이지에서 제공되는 할인 상품은 땅집고옥션의 다른
              이벤트(할인·프로모션 등)와 중복 적용되지 않습니다.
            </Note>
          </Membership>
          <span
            style={{
              fontSize: '16px',
              color: 'rgba(55, 56, 60, 0.61)',
              fontWeight: '500',
              textAlign: 'center',
              wordBreak: 'keep-all',
              padding: '0 16px',
            }}
          >
            ※ 공인중개사 전용 유료 이용권을 구매하실 경우,{' '}
            <a
              style={{ color: '#008AFF' }}
              href="mailto:biz@transfarmer.co.kr"
              target="_blank"
              rel="noopener noreferrer"
            >
              biz@transfarmer.co.kr
            </a>
            로 구매자명, 공인중개사 자격증 사본을 첨부 바랍니다
          </span>
        </TitleBox>
      </Section>

      <CardBenefitSection>
        <CardBenefitSectionTitle>
          <img src="/assets/images/icon/info-black.svg" alt="" />
          추가 혜택 안내
        </CardBenefitSectionTitle>
        <CardBenefitSectionContent>
          <CardBenefit>
            ・
            <CardBenefitText>
              최대 6개월! 무이자 할부
              <CardName>신한, KB, 국민, 하나, 롯데, 농협, 우리, 전북</CardName>
              <CardDesc>
                개인사업자, 법인, 체크카드, 기프트카드, BC계열 무이자 제외
              </CardDesc>
            </CardBenefitText>
          </CardBenefit>
          <CardBenefit>
            ・<CardBenefitText>쿠폰 적용 시 추가 할인가능</CardBenefitText>
          </CardBenefit>
        </CardBenefitSectionContent>
      </CardBenefitSection>

      <ComparePlan />
      <ComparePrice />

      <InfoBox>
        <InfoBoxTitle>
          <img src="/assets/images/icon/info-black.svg" alt="" />
          요금제 유의사항
        </InfoBoxTitle>
        <InfoContent>
          <InfoItem>
            <div>・</div>모든 요금제는 부가세가 포함된 금액입니다.
          </InfoItem>
          <InfoItem>
            <div>・</div>스탠다드 지역권을 구매하실 경우 일부 지역 서비스는
            제한됩니다.
          </InfoItem>
          <InfoItem>
            <div>・</div>이용기간 안내: 1개월 상품은 구매일 기준 30일간 이용
            가능합니다.
          </InfoItem>
          <InfoItem>
            <div>・</div>3개월 이상 상품 구매 시, 리포트 열람권은 요금제 가입일
            기준으로 1개월마다 50건씩 자동 지급됩니다.
            <br />
            (예: 7월 10일 구매 시 50건 충전, 8월 9일에 다음 50건 충전)
          </InfoItem>
          <InfoItem>
            <div>・</div>지급된 열람권은 해당 30일 내에만 사용 가능하며,
            이월되거나 누적되지 않습니다. <br />
            요금제 사용 중에만 지급되며, 기간 종료 시 남은 열람권은 자동
            소멸됩니다.
          </InfoItem>
          <InfoItem>
            <div>・</div>1년권(365일)의 경우, 총 12회에 걸쳐 최대 600건의
            열람권이 순차적으로 지급됩니다.
          </InfoItem>
          <InfoItem>
            <div>・</div>AI 경공매 찾기 탐색권 : 무료 회원 매 월 1일 30건 /
            스탠다드 결제일 기준 30일마다 300건/ 프리미엄 결제일 기준 30일마다
            1000건
          </InfoItem>
        </InfoContent>
      </InfoBox>
      <Footer />
      <Footer />
    </Container>
  );
};

export default AgentPaymentPlan;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  background: #fff;
  word-break: keep-all;
`;

const Top = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-bottom: 42px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const PageTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 28px;
  font-weight: 700;
  line-height: 34.8px;
  color: #222222;
  text-align: center;
`;

const Description = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #616161;
`;

const Option = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Membership = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const OptionButton = styled.div<{ selected: boolean }>`
  width: 50%;
  padding: 12px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? '#008AFF' : '#f7f7f8;')};
  color: ${({ selected }) => (selected ? '#fff' : '#616161')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Early = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: #008aff;
  padding: 8px 16px;
  background-color: #e8f1ff;
  text-align: center;
  border-radius: 8px;
`;

const Note = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-size: 13px;
  font-weight: 500;
`;

const CardBenefitSection = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  background: #f7f7fa;
`;

const CardBenefitSectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const CardBenefitSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const CardBenefit = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;

  color: #222;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const CardBenefitText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`;

const CardName = styled.div`
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const CardDesc = styled.div`
  color: #616161;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const InfoBox = styled.div`
  display: flex;
  padding: 24px 16px 40px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  background: #f7f7fa;
`;

const InfoBoxTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;

  color: #616161;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const Section = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: center;
`;
